import { z } from "zod";
import { WirePlan } from "./attack.js";
import { LayoutPayload } from "./layout.js";
import { VillageEconomy, WireResources } from "./village.js";

/** Wire shapes for guide rewards, Trials and the supply wagon (29 Sep 2026). */

export const GoalsResponse = z.object({ claimed: z.array(z.string()) });
export type GoalsResponse = z.infer<typeof GoalsResponse>;

export const RewardResponse = z.object({
  /** What was paid. All zero when it had already been paid. */
  reward: WireResources,
  village: VillageEconomy,
});
export type RewardResponse = z.infer<typeof RewardResponse>;

export const TrialProgress = z.object({
  trialId: z.string(),
  stars: z.number().int().min(0).max(3),
});
export const TrialsResponse = z.object({ progress: z.array(TrialProgress) });
export type TrialsResponse = z.infer<typeof TrialsResponse>;

export const TrialAttempt = z.union([
  z.object({ plan: WirePlan }),
  z.object({ layout: LayoutPayload }),
]);
export type TrialAttempt = z.infer<typeof TrialAttempt>;

export const TrialResult = z.object({
  recovered: z.boolean().optional(),
  stars: z.number().int().min(0).max(3),
  /** The best this village has ever done on it, after this attempt. */
  best: z.number().int().min(0).max(3),
  reward: WireResources,
  village: VillageEconomy,
});
export type TrialResult = z.infer<typeof TrialResult>;
